/** 
* Issue - GTM @event "platform_type" doesnt fire on first app init 
* fire GTM @event "platform_type" on first app init , only once.
* @see inAppGtm plugin
*/

import { inAppGtm } from '@/lib/gtm';
import { mapState } from 'vuex';

export default {

  computed: {
    ...mapState({
      firedInAppGtmFlag: (state) => state.homeDrushim.firedInAppGtmFlag,
    }),
  },
  mounted() {
    if (!this.firedInAppGtmFlag) {
      inAppGtm();
      this.$store.commit('UPDATE_INAPP_GTM_FLAG', true);
    }
  }
}